/**
 * Código de erro de domínio do backend (`{ error: 'ACCOUNT_NOT_FOUND', ... }`).
 *
 * `undefined` quando não houve resposta (rede caiu), quando o corpo não tem esse
 * formato (5xx cru) ou quando o erro nem veio do axios (ex.: erro do Firebase).
 * Ponto único: quem trata erro lê daqui em vez de cavar `err.response` na mão.
 */
export function extractApiErrorCode(err: unknown): string | undefined {
  if (typeof err !== 'object' || err === null || !('response' in err)) {
    return undefined;
  }
  return (err as { response?: { data?: { error?: string } } }).response?.data
    ?.error;
}

/**
 * O backend respondeu (houve resposta HTTP) — distingue de queda de rede.
 *
 * A diferença importa em quem decide derrubar a sessão: uma recusa do servidor
 * é motivo, um cabo desconectado não é.
 */
export function isApiError(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'response' in err &&
    (err as { response?: unknown }).response != null
  );
}

/**
 * Status HTTP da resposta, quando houve resposta. `undefined` para queda de rede
 * ou erro que não veio do axios.
 *
 * Serve a quem precisa distinguir "o backend recusou o VALOR" (400 da validação,
 * que não carrega código de domínio) de "recusou a AUTORIZAÇÃO" (403 com código).
 */
export function extractApiErrorStatus(err: unknown): number | undefined {
  if (typeof err !== 'object' || err === null || !('response' in err)) {
    return undefined;
  }
  const status = (err as { response?: { status?: unknown } }).response?.status;
  return typeof status === 'number' ? status : undefined;
}
